<template>
    <div>

        <PageHeader>
            {{ $t('configurations') }}
            <template #side>
                <ButtonIcon icon="plus" @click="addConfiguration()">{{ $t('addConfiguration') }}</ButtonIcon>
            </template>
            <template #subtitle>
                <div>{{ $t('forEachPageAddedYouCanCreateALotOfConfigurations') }}</div>
            </template>
            <template #bottom>
                <div class="d-flex gap-3">
                    <ButtonIcon
                        icon="file-text"
                        :icon-size="24"
                        href="https://getbuybox.com/konfiguracje/"
                        target="_blank"
                        variant="link"
                        class="p-0"
                    >
                        {{ $t('learnMoreHowToUseConfiguration') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <Card :header="$t('configurationList')" header-id="WTB-Konfig-header-1">

            <div v-if="request.loading && !items.length" class="d-flex justify-content-center my-2">
                <b-spinner />
            </div>

            <template v-else-if="items.length">
                <Filters ref="Filters" />
                <Results ref="Results" />
            </template>

            <AddFirstConfiguration v-else />

            <ModalAddConfiguration />
        </Card>
    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import Filters from './parts/Filters.vue';
    import Results from './parts/Results.vue';
    import AddFirstConfiguration from './parts/AddFirstConfiguration.vue';
    import ModalAddConfiguration from './parts/ModalAddConfiguration.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({
        space: null,
    });
    const DEFAULT_TABLE_PARAMS = Object.freeze({});

    export default {
        name: 'WidgetSettings',
        mixins: [viewFiltersMixin],
        components: {
            Filters,
            Results,
            AddFirstConfiguration,
            ModalAddConfiguration,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('buyboxes/publishers'),
                localFiltering: true,
            };
        },
        computed: {
            user() {
                return this.$store.getters['auth/getUser'];
            },
            urlParams() {
                return { id: this.user.id };
            },
        },
        methods: {
            addConfiguration() {
                this.$root.$emit('bv::show::modal', 'modal-form-buyboxes-spaces');
            },
        },
        mounted() {
            if (this.$route.query.space || this.$route.query.add) this.addConfiguration();
        },
    };
</script>
